const INITIAL_SNAKE_SPEED = 1;
const SNAKE_SPEED_MULTIPLIER = 0.05;
const SPEED_UP_STREAK_AMOUNT = 3;
const SLOW_DOWN_STREAK_AMOUNT = 2;

type StreakState = {
	correctStreak: number;
	incorrectStreak: number;
	snakeSpeed: number;
};

type StreakAction = { type: 'answer'; correct: boolean } | { type: 'reset' };

export const initialStreakState: StreakState = {
	correctStreak: 0,
	incorrectStreak: 0,
	snakeSpeed: INITIAL_SNAKE_SPEED,
};

export const streakReducer = (state: StreakState, action: StreakAction): StreakState => {
	if (action.type === 'reset') {
		return initialStreakState;
	}

	if (action.correct) {
		const nextCorrectStreak = state.correctStreak + 1;

		if (nextCorrectStreak >= SPEED_UP_STREAK_AMOUNT) {
			return {
				correctStreak: 0,
				incorrectStreak: 0,
				snakeSpeed: state.snakeSpeed + state.snakeSpeed * SNAKE_SPEED_MULTIPLIER,
			};
		}

		return {
			...state,
			correctStreak: nextCorrectStreak,
			incorrectStreak: 0,
		};
	}

	const nextIncorrectStreak = state.incorrectStreak + 1;

	if (nextIncorrectStreak >= SLOW_DOWN_STREAK_AMOUNT) {
		return {
			correctStreak: 0,
			incorrectStreak: 0,
			snakeSpeed: state.snakeSpeed - state.snakeSpeed * SNAKE_SPEED_MULTIPLIER,
		};
	}

	return {
		...state,
		correctStreak: 0,
		incorrectStreak: nextIncorrectStreak,
	};
};
